var requiredJSLoaded = false;


namespace Pages.Test._Controls.Login {

    export function __cdn_pages_test_control_login_onDocumentReady() {

        let login = new CDN.Controls.Login(document.body, {
            onLogin: (result) => {
                console.log(result);
            },
            onError: (lvl, msg, data) => {
                console.error(msg);
                if (data)
                    console.error(data);
            },
        });
    }
}

CDN.requireOnce([
    { code: CDN.PackageCode.JQuery, },
    { code: CDN.PackageCode.Common, },
    { code: CDN.PackageCode.Control_Login, },
], () => {
    requiredJSLoaded = true;
    $(document).ready(Pages.Test._Controls.Login.__cdn_pages_test_control_login_onDocumentReady);
});